import { useLayoutEffect, useRef } from "react";

/**
 * Mirrors a value into a ref so stable callbacks can read it without re-creating.
 *
 * @param value - The value to mirror.
 * @returns A ref holding the most recent value.
 */
export const useLatestRef = <T>(value: T) => {
    const ref = useRef(value);

    useLayoutEffect(() => {
        ref.current = value;
    }, [value]);

    return ref;
};
